import cn from 'classnames'

type SectionBlendGlowProps = {
  uid: string
  className?: string
}

const NOISE_TABLE_1 =
  '1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0'

const NOISE_TABLE_2 =
  '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1'

const RECT_TRANSFORM = 'matrix(1 0 0 -1 -64 349)'

export const SectionBlendGlow = ({uid, className}: SectionBlendGlowProps) => (
  <svg
    className={cn('overflow-visible', className)}
    fill="none"
    height="449"
    preserveAspectRatio="none"
    viewBox="0 0 1442 449"
    width="1442"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter={`url(#filter0_fn_${uid})`}>
      <rect fill={`url(#paint0_linear_${uid})`} height="249" transform={RECT_TRANSFORM} width="1555" />
      <rect fill={`url(#paint1_linear_${uid})`} height="249" transform={RECT_TRANSFORM} width="1555" />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="449"
        id={`filter0_fn_${uid}`}
        width="1755"
        x="-164"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feGaussianBlur result={`effect1_foregroundBlur_${uid}`} stdDeviation="50" />
        <feTurbulence
          baseFrequency="1 1"
          numOctaves="3"
          result="noise"
          seed="2512"
          stitchTiles="stitch"
          type="fractalNoise"
        />
        <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA tableValues={NOISE_TABLE_1} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise1" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise1Clipped" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise2">
          <feFuncA tableValues={NOISE_TABLE_2} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise2" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise2Clipped" />
        <feFlood floodColor="rgba(0, 36, 20, 0.5)" result="color1Flood" />
        <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
        <feFlood floodColor="rgba(255, 255, 255, 0.5)" result="color2Flood" />
        <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
        <feMerge result={`effect2_noise_${uid}`}>
          <feMergeNode in={`effect1_foregroundBlur_${uid}`} />
          <feMergeNode in="color1" />
          <feMergeNode in="color2" />
        </feMerge>
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id={`paint0_linear_${uid}`}
        x1="296.936"
        x2="296.937"
        y1="0"
        y2="249"
      >
        <stop stopColor="#B9FF3F" />
        <stop offset="0.846242" stopColor="#B9FF3F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id={`paint1_linear_${uid}`}
        x1="777.5"
        x2="777.5"
        y1="0"
        y2="124.5"
      >
        <stop stopColor="transparent" />
        <stop offset="1" stopColor="transparent" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
